var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "dropdown-menu dropdown-menu-right text-left" }, [
      _c(
        "ul",
        { staticClass: "list-unstyled mb-0" },
        [
          _vm._l(_vm.actions, function(action) {
            return [
              _c("li", { key: action.name }, [
                _c(
                  "a",
                  {
                    key: action.name,
                    staticClass: "dropdown-item",
                    attrs: { href: _vm.formatLink(action.link) }
                  },
                  [_vm._v(_vm._s(action.label || action.name))]
                )
              ])
            ]
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-trans ml-sm-2",
        attrs: { type: "button", "data-toggle": "dropdown" }
      },
      [_c("i", { staticClass: "material-icons" }, [_vm._v("more_horiz")])]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e58bfb2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e58bfb2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/DropdownActionsButtonComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6e58bfb2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/DropdownActionsButtonComponent.vue
// module chunks = 0